module.exports = __webpack_public_path__ + "static/img/dcjyxt.a7e6518.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/about/C01_dcjyxt/dcjyxt.png
// module id = 1y1X
// module chunks = 0